module.exports = __webpack_public_path__ + "static/media/Reminder.41a73348.png";